import { BaseAdapter } from '@data/base/base-adapter.type';
import { MsisdnForwardingRespDto } from '../../models/msisdn-forwarding.dto';
import { MsisdnForwardingEntity } from '@data/domain/msisdn-forwarding.entity';
import { MsisdnTransformerBuilder } from '@shared/utils.msisdn-transformer';

export class MsisdnForwardingAdapter implements BaseAdapter<MsisdnForwardingRespDto, MsisdnForwardingEntity> {
  mapFrom(dto: MsisdnForwardingRespDto): MsisdnForwardingEntity {
    const transformer = new MsisdnTransformerBuilder().build();

      return {
        msisdn: transformer.transform(dto.data.msisdn) ?? ''
      };
  }
}